export default __webpack_public_path__ + "static/media/dashboard-footer.3fca5177.svg";